export let Code = {
type: `@Component({
    selector: 'p-confirmDialog',
    template:
        <p-growl [value]="msgs"></p-growl>
        <p-confirmDialog></p-confirmDialog>
        <button type="button" (click)="confirm1()" pButton icon="ion-checkmark-round" label="Confirm"></button>
        <button type="button" (click)="confirm2()" pButton icon="ion-close-round" label="Delete"></button>
})
export class ConfirmDialog {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/confirm.ts